import type { FC, ReactNode, SVGProps } from 'react';
import { ActionTooltip } from './ActionTooltip';

interface TaskActionButtonsProps {
  onViewDetails?: () => void;
  onEdit: () => void;
  onDelete: () => void;
  extraAction?: ReactNode;
}

const ViewIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
  </svg>
);

const DeleteIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 6h18" />
    <path d="M8 6V4h8v2" />
    <path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);

export const TaskActionButtons: FC<TaskActionButtonsProps> = ({ onViewDetails, onEdit, onDelete, extraAction }) => {
  return (
    <div className="action-buttons">
      {onViewDetails && (
        <ActionTooltip label="View task details">
          <button
            type="button"
            className="btn btn-icon btn-secondary"
            onClick={onViewDetails}
            aria-label="View task details"
          >
            <ViewIcon className="action-icon" aria-hidden="true" />
          </button>
        </ActionTooltip>
      )}
      {extraAction}
      <ActionTooltip label="Edit task">
        <button
          type="button"
          className="btn btn-icon btn-primary"
          onClick={onEdit}
          aria-label="Edit task"
        >
          <EditIcon className="action-icon" aria-hidden="true" />
        </button>
      </ActionTooltip>
      <ActionTooltip label="Delete task">
        <button
          type="button"
          className="btn btn-icon btn-danger"
          onClick={onDelete}
          aria-label="Delete task"
        >
          <DeleteIcon className="action-icon" aria-hidden="true" />
        </button>
      </ActionTooltip>
    </div>
  );
};